module.exports = __webpack_public_path__ + "media/images/Phone-outline-3d622bbf.svg";